import AppleIcon from '@/assets/icons/apple.svg?react';
import GooglePlayColorIcon from '@/assets/icons/google-play-color.svg?react';
import { trackDownloadAppButtonClicked } from '@/features/analytics/track/trackDownloadAppButtonClicked';
import {
  APP_STORE_LINK,
  PLAY_STORE_LINK,
} from '@/features/download/constants/appStoreLinks';

export function DownloadModalStoreBadges() {
  return (
    <div className="mt-4 flex flex-wrap items-center justify-start gap-3">
      <a
        href={PLAY_STORE_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackDownloadAppButtonClicked({
            source: 'download_modal_store_badge_google',
          });
        }}
        className="border-cold-500 flex h-11 items-center gap-2 rounded-lg border bg-black px-3 transition-opacity hover:opacity-80"
      >
        <GooglePlayColorIcon className="h-6 w-5" />
        <div className="flex flex-col items-start">
          <span className="font-nunito text-[9px] leading-tight tracking-wide text-white/80">
            GET IT ON
          </span>
          <span className="font-nunito text-base leading-tight font-medium text-white">
            Google Play
          </span>
        </div>
      </a>
      <a
        href={APP_STORE_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackDownloadAppButtonClicked({
            source: 'download_modal_store_badge_apple',
          });
        }}
        className="border-cold-500 flex h-11 items-center gap-2 rounded-lg border bg-black px-3 transition-opacity hover:opacity-80"
      >
        <AppleIcon className="size-6 text-white" />
        <div className="flex flex-col items-start">
          <span className="font-nunito text-[9px] leading-tight tracking-wide text-white/80">
            Download on the
          </span>
          <span className="font-nunito text-base leading-tight font-medium text-white">
            App Store
          </span>
        </div>
      </a>
    </div>
  );
}
